<template lang="pug">
.quantity
  template(v-if="item.isParent || item.isChild")
    .text-sm(v-if="item.isChild") {{ item.quantity }}
  template(v-else)
    v-text-field.text-sm.round-xl(v-if="item.editable && item.productItem.type !== 'documents'" v-model.number="quantity" outlined hide-details type="number" dense :rules="inventoryEnabled ? rules.allowed_quantity : []" @input="updateQuantity(quantity)")
    div(v-else-if="item.quantity >= 1" :class="{ 'clickable':isClickable }")
      span.font-semibold.danger500--text(v-if="item.error") {{ item.quantity }}
      span(v-else) {{ item.quantity }}
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
  },
  data () {
    return {
      quantity: null,
      maxStock: null,
      rules: {
        allowed_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required', v => v <= this.maxStock || 'Item quantity more than available stock'],
      },
    }
  },
  computed: {
    inventoryEnabled () {
      return this.item.productItem.inventory_enabled
    },
    balanceQuantity () {
      return this.item.productItem.inventory_qty
    },
    isClickable () {
      if (this.item.productItem.type === 'documents') {
        return false
      }
      return true
    }
  },
  watch: {
    balanceQuantity () {
      this.setInit()
    },
    'item.editable' () {
      this.setInit()
    }
  },
  mounted () {
    this.setInit()
  },
  methods: {
    ...mapActions(['showMessage']),
    setInit () {
      this.quantity = Number(this.item.quantity)
      this.maxStock = this.item.error ? Number(this.item.productItem.inventory_qty) : Number(this.item.quantity + this.item.productItem.inventory_qty)
    },
    updateQuantity (quantity) {
      let qty = quantity
      if (this.inventoryEnabled) {
        if (qty > this.maxStock) {
          this.showMessage(['error', 'Item quantity more than available stock'])
          qty = this.maxStock
        } else if (!qty) {
          qty = 1
        }
      }
      this.item.quantity = qty
      this.$emit('changed', this.item)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>